export default class Permission {
  setControls(path) {
    let status;
    if (
      localStorage.getItem("yallaQata_Admin_Dash_User_Type") != "superadmin"
    ) {
      if (localStorage.getItem("bro_controls")) {
        let controls = JSON.parse(localStorage.getItem("bro_controls"));
        const found = controls.find((control) => control.url == path);

        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
  allowed(path) {
    let status;
    if (
      localStorage.getItem("yallaQata_Admin_Dash_User_Type") != "superadmin"
    ) {
      if (localStorage.getItem("bro_permissions")) {
        let controls = JSON.parse(localStorage.getItem("bro_permissions"));

        const found = controls.find((control) => control.url == path);
        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
}

